import React from 'react';

const AboutOne = () => {
  return (
    <section className="about-one">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 wow fadeInLeft" data-wow-delay="300ms">
            <div className="about-one__left" style={{ textAlign: 'left' }}>
              <div className="section-title text-left sec-title-animation animation-style2" style={{ textAlign: 'left' }}>
                <div className="section-title__tagline-box">
                  <span className="section-title__tagline">About Rayyan Aid</span>
                </div>
                <h2 className="section-title__title title-animation">Serving with dignity to <span>uplift</span> <span>communities</span></h2>
              </div>
              <p className="about-one__text" style={{ textAlign: 'left' }}>Rayyan Aid is a non‑profit organization delivering dignified support across education, healthcare, nutrition and emergency relief. We partner with local communities to build sustainable solutions and create lasting change with transparency and impact.</p>
              <ul className="about-one__points list-unstyled" style={{ textAlign: 'left' }}>
                <li>
                  <div className="about-one__points-icon">
                    <span className="icon-healthcare"></span>
                  </div>
                  <div className="about-one__points-content">
                    <h3>Healthcare Access</h3>
                  </div>
                </li>
                <li>
                  <div className="about-one__points-icon">
                    <span className="icon-fund-raising"></span>
                  </div>
                  <div className="about-one__points-content">
                    <h3>Transparent Fundraising</h3>
                  </div>
                </li>
              </ul>
              <ul className="about-one__points-2 list-unstyled" style={{ textAlign: 'left' }}>
                <li>
                  <div className="icon"><span className="icon-check"></span></div>
                  <p>Community‑led programs with measurable outcomes</p>
                </li>
                <li>
                  <div className="icon"><span className="icon-check"></span></div>
                  <p>Every donation tracked to real impact</p>
                </li>
                <li>
                  <div className="icon"><span className="icon-check"></span></div>
                  <p>Focus areas: Education, Healthcare, Nutrition, Relief</p>
                </li>
              </ul>
              <div className="about-one__btn-and-contact-box">
                <div className="about-one__btn-box">
                  <a href="/about" className="thm-btn">
                    <span className="thm-btn-text">Learn More</span>
                    <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
                  </a>
                </div>
                <div className="about-one__contact-box">
                  <div className="icon"><span className="icon-call"></span></div>
                  <div className="content">
                    <h3>Need help?</h3>
                    <p><a href="tel:07063653772">07063653772</a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6 wow slideInRight" data-wow-delay="100ms" data-wow-duration="2500ms">
            <div className="about-one__right">
              <div className="about-one__img-box">
                <div className="about-one__img">
                  <img src="assets/images/18.jpg" alt="About Rayyan Aid" />
                </div>
                <div className="about-one__img-2">
                  <img style={{ width: '200px', height: '200px', objectFit: 'cover' }} src="assets/images/30.jpg" alt="" />
                </div>
                <div className="about-one__found-box-inner">
                  <div className="about-one__found-box">
                    <div className="about-one__found-icon"><span className="icon-fund-raising"></span></div>
                    <h5 className="about-one__found-title">We’ve funded<br/> <span className="odometer" data-count="50">00</span>K Naira</h5>
                  </div>
                </div>
                <div className="about-one__video-and-support">
                  <div className="about-one__video-link">
                    <a href="https://www.youtube.com/watch?v=Get7rqXYrbQ" className="video-popup">
                      <div className="about-one__video-icon">
                        <span className="fa fa-play"></span>
                        <i className="ripple"></i>
                      </div>
                    </a>
                  </div>
                  <div className="about-one__support"><span>24 hour Support</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutOne;
